import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-tracking-redirect',
	template: `<p>Redirecting...</p>`
})
export class TrackingRedirectComponent implements OnInit {

	constructor(
		private route: ActivatedRoute,
		private router: Router
	) { }

	ngOnInit(): void {
		const upi = this.route.snapshot.paramMap.get('upi')!;
		const postcode = this.route.snapshot.paramMap.get('postcode')!;

		// Insert space before last 3 characters → WV68BN → WV6 8BN
		const formattedPostcode =
			postcode.slice(0, -3) + ' ' + postcode.slice(-3);

		this.router.navigate(
			['/tracking-history'],
			{
				queryParams: {
					upi,
					postcode: formattedPostcode
				}
			}
		);
	}
}
